import { cn } from "@/lib/utils";

export function ModalSummaryBar({ badge, amount, meta, className }) {
  return (
    <div
      className={cn(
        "flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 bg-slate-50/80 px-4 py-3",
        className,
      )}
    >
      <div className="min-w-0 flex-1">{badge}</div>
      {amount != null ? <div className="shrink-0 font-display text-xl font-bold tabular-nums">{amount}</div> : null}
      {meta ? <p className="w-full text-xs text-slate-500">{meta}</p> : null}
    </div>
  );
}

export function ModalSection({ title, children, className }) {
  return (
    <section className={cn("space-y-2", className)}>
      {title ? (
        <h3 className="text-[10px] font-semibold uppercase tracking-wide text-slate-500">{title}</h3>
      ) : null}
      {children}
    </section>
  );
}

export function ModalContactCard({ rows, onMoreDetails, moreLabel = "Voir la fiche complète" }) {
  if (!rows?.length && !onMoreDetails) return null;
  return (
    <div className="rounded-xl border border-emerald-200 bg-emerald-50/90 p-4 space-y-3">
      <p className="text-sm font-semibold text-emerald-950">Coordonnées débloquées</p>
      {rows?.length ? (
        <dl className="grid gap-2 text-sm sm:grid-cols-2">
          {rows.map(({ label, value, href }) => (
            <div key={label} className={label === "Adresse" ? "sm:col-span-2" : undefined}>
              <dt className="text-[10px] font-semibold uppercase text-slate-500">{label}</dt>
              <dd className="font-medium text-slate-900 break-words">
                {href ? (
                  <a href={href} className="text-[#2D7FF9] hover:underline">
                    {value}
                  </a>
                ) : (
                  value
                )}
              </dd>
            </div>
          ))}
        </dl>
      ) : null}
      {onMoreDetails ? (
        <button
          type="button"
          className="text-sm font-semibold text-[#2D7FF9] hover:underline"
          onClick={onMoreDetails}
        >
          {moreLabel} →
        </button>
      ) : null}
    </div>
  );
}

export function ModalActions({ children, className }) {
  if (!children) return null;
  return <div className={cn("flex flex-wrap gap-2 border-t border-slate-100 pt-4", className)}>{children}</div>;
}
